var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDislike = function SvgDislike(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 9.142h2.857V.57H13v8.572ZM10.143.57H3.714c-.593 0-1.1.357-1.314.872L.243 6.477c-.064.165-.1.336-.1.522v1.428A1.429 1.429 0 0 0 1.57 9.856H6.08L5.4 13.12a1.063 1.063 0 0 0 .293.979l.757.757 4.7-4.707c.264-.257.421-.614.421-1.007V1.999A1.429 1.429 0 0 0 10.143.57Z",
    fill: "var(--default-text-color)"
  })));
};

export default SvgDislike;